// lib/leasing/expansionChartYears.ts
//
// The years the Expansion tab draws, shared by the chart and by GATHER_EVIDENCE so the agent reads
// exactly the bars the user is looking at (it answered "does this match our graph?" from the
// summary alone, 2026-09-26).
import type { BrandExpansionPeriod } from '#types/types';

export type ExpansionChartYear = { year: string; openings: number; closures: number };

/** Selected recorded years, with interior gaps filled; closures are positive. */
export const expansionChartYears = (
  openingsByYear: Record<string, number> = {},
  closuresByYear: Record<string, number> = {},
  period: BrandExpansionPeriod = '6y',
): ExpansionChartYear[] => {
  const years = [...Object.keys(openingsByYear), ...Object.keys(closuresByYear)]
    .filter((y) => /^[1-9]\d{3}$/.test(y))
    .map(Number);
  if (!years.length) return [];
  const maxYear = Math.max(...years);
  const minYear = Math.min(...years);
  const singleYear = typeof period === 'number';
  if (singleYear && (!Number.isInteger(period) || period < minYear || period > maxYear)) return [];
  const end = singleYear ? period : maxYear;
  const count = period === '3y' ? 3 : period === '10y' ? 10 : 6;
  const start = singleYear ? period : period === 'all' ? minYear : Math.max(minYear, end - count + 1);
  const out: ExpansionChartYear[] = [];
  for (let y = start; y <= end; y++) {
    out.push({ year: String(y), openings: openingsByYear[String(y)] ?? 0, closures: closuresByYear[String(y)] ?? 0 });
  }
  return out;
};
